import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import DashboardScreen from './screens/DashboardScreen';
import LoginScreen from './screens/LoginScreen';
import RegisterScreen from './screens/RegisterScreen';
import PendingScreen from './screens/PendingScreen';
import OperatorLoginScreen from './screens/OperatorLoginScreen';
import OperatorAppScreen from './screens/OperatorAppScreen';
import IncomingListScreen from './screens/IncomingListScreen';
import IncomingStockScreen from './screens/IncomingStockScreen';
import IncomingDetailScreen from './screens/IncomingDetailScreen';
import ProductionOrdersScreen from './screens/ProductionOrdersScreen';
import ProductionOrderFormScreen from './screens/ProductionOrderFormScreen';
import ProductionPlanningScreen from './screens/ProductionPlanningScreen';
import AuditsScreen from './screens/AuditsScreen';
import AuditFormScreen from './screens/AuditFormScreen';
import AuditDetailScreen from './screens/AuditDetailScreen';
import PalletsScreen from './screens/PalletsScreen';
import PalletDetailScreen from './screens/PalletDetailScreen';
import RecallsScreen from './screens/RecallsScreen';
import RecallFormScreen from './screens/RecallFormScreen';
import RecallDetailScreen from './screens/RecallDetailScreen';
import MasterDataScreen from './screens/MasterDataScreen';
import UsersScreen from './screens/UsersScreen';
import SupplierDocumentsScreen from './screens/SupplierDocumentsScreen';
import ProfileScreen from './screens/ProfileScreen';
import HelpScreen from './screens/HelpScreen';
import ProductionRecipesScreen from './screens/ProductionRecipesScreen';
import ProductionRecipeFormScreen from './screens/ProductionRecipeFormScreen';
import ShopfloorScreen from './screens/ShopfloorScreen';
import ReceiveGoodsScreen from './screens/ReceiveGoodsScreen';
import ProductionStartScreen from './screens/ProductionStartScreen';
import StockScreen from './screens/StockScreen';
import TraceTestScreen from './screens/TraceTestScreen';
import ProcessViewerScreen from './screens/ProcessViewerScreen';

/**
 * Inner routes for the prototype. In App.js use:
 *   <Route path="prototype" element={<PrototypeLayout />}>
 *     {PrototypeRouteChildren}
 *   </Route>
 *
 * Must be a Fragment (not a component) - React Router v6 requires Route/Fragment
 * as direct children, not custom components.
 */
export const PrototypeRouteChildren = (
  <>
    <Route index element={<Navigate to="dashboard" replace />} />
      <Route path="dashboard" element={<DashboardScreen />} />
      <Route path="login" element={<LoginScreen />} />
      <Route path="register" element={<RegisterScreen />} />
      <Route path="pending" element={<PendingScreen />} />
      <Route path="operator" element={<OperatorAppScreen />} />
      <Route path="operator/login" element={<OperatorLoginScreen />} />
      <Route path="incoming-deliveries" element={<IncomingListScreen />} />
      <Route path="incoming-deliveries/stock" element={<IncomingStockScreen />} />
      <Route path="incoming-deliveries/:id" element={<IncomingDetailScreen />} />
      <Route path="production-orders" element={<ProductionOrdersScreen />} />
      <Route path="production-orders/new" element={<ProductionOrderFormScreen />} />
      <Route path="production-orders/:id/edit" element={<ProductionOrderFormScreen />} />
      <Route path="production-planning" element={<ProductionPlanningScreen />} />
      <Route path="audits" element={<AuditsScreen />} />
      <Route path="audits/new" element={<AuditFormScreen />} />
      <Route path="audits/:id" element={<AuditDetailScreen />} />
      <Route path="audits/:id/edit" element={<AuditFormScreen />} />
      <Route path="pallets" element={<PalletsScreen />} />
      <Route path="pallets/:id" element={<PalletDetailScreen />} />
      <Route path="recalls" element={<RecallsScreen />} />
      <Route path="recalls/new" element={<RecallFormScreen />} />
      <Route path="recalls/:id" element={<RecallDetailScreen />} />
      <Route path="recalls/:id/edit" element={<RecallFormScreen />} />
      <Route path="trace-test-auto" element={<TraceTestScreen />} />
      <Route path="supplier-documents" element={<SupplierDocumentsScreen />} />
      <Route path="production-recipes" element={<ProductionRecipesScreen />} />
      <Route path="production-recipes/new" element={<ProductionRecipeFormScreen />} />
      <Route path="production-recipes/:id" element={<ProductionRecipeFormScreen />} />
      <Route path="production-recipes/:id/edit" element={<ProductionRecipeFormScreen />} />
      <Route path="shopfloor" element={<ShopfloorScreen />} />
      <Route path="receive-goods" element={<ReceiveGoodsScreen />} />
      <Route path="production-start" element={<ProductionStartScreen />} />
      <Route path="stock" element={<StockScreen />} />
      <Route path="processes" element={<ProcessViewerScreen />} />
      <Route path="administration/master-data" element={<MasterDataScreen />} />
      <Route path="administration/users" element={<UsersScreen />} />
      <Route path="profile" element={<ProfileScreen />} />
      <Route path="help" element={<HelpScreen />} />
  </>
);

export { default as PrototypeLayout } from './PrototypeLayout';
export default PrototypeRouteChildren;
